import { IconButton, InputAdornment } from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import { DateTimePicker } from '@material-ui/pickers';
import formatISO from 'date-fns/formatISO';
import React, { FunctionComponent, useState } from 'react';

export interface DateTimeFieldProps {
    label: string;
    value: Date|null;
    onChange: (newValue: Date|null) => void;
    className?: string;
    required?: boolean;
    helperText?: string;
    ampm?: boolean;
    utc?: boolean;
    error?: boolean;
    format: string;
    disabled?: boolean;
    disableClear?: boolean;
}

const DateTimeField: FunctionComponent<DateTimeFieldProps> = ({
    label, value, onChange, className, required,
    ampm, helperText, utc, error, format, disabled, disableClear,
}) => {
    const [hovering, setHovering] = useState(false);
    const [focusing, setFocusing] = useState(false);

    return (
        <DateTimePicker
            value={value}
            onChange={newValue => {
                const result = (() => {
                    if (newValue === null) {
                        return null;
                    }

                    return utc
                        ? new Date(formatISO(newValue))
                        : newValue;
                })();

                onChange(result);
            }}
            onMouseEnter={() => setHovering(true)}
            onMouseLeave={() => setHovering(false)}
            onFocus={() => setFocusing(true)}
            onBlur={() => setFocusing(false)}
            label={utc ? `${label} (UTC)` : label}
            className={className}
            required={required}
            // eslint-disable-next-line max-len
            // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing, @typescript-eslint/no-unnecessary-condition
            helperText={helperText || ' '}
            inputVariant="filled"
            ampm={ampm ?? false}
            autoOk
            variant="inline"
            disabled={disabled}
            InputProps={{
                endAdornment: (hovering || focusing) && !disableClear && value !== null
                    ? (
                        <InputAdornment position="end">
                            <IconButton

                                // TODO: Translate
                                aria-label="Clear"
                                onClick={event => {
                                    event.stopPropagation();
                                    onChange(null);
                                }}
                                onMouseDown={event => event.preventDefault()}
                            >
                                <ClearIcon/>
                            </IconButton>
                        </InputAdornment>
                    )
                    : null,
            }}
            fullWidth
            error={error}
            format={format}
        />
    );
};

export default DateTimeField;
